module.exports = __webpack_public_path__ + "img/message-sign.3e9639a3.png";